<div class="pulse">
  <span style="--i: 0"></span>
  <span style="--i: 1"></span>
  <span style="--i: 2"></span>
  <span style="--i: 3"></span>

  <icons-component
    [iconName]="icon"
    class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-1/2 w-1/2"
    fill="#002266"
  ></icons-component>
</div>
